import { createSlice } from "@reduxjs/toolkit";
import {
  fetchWarehousePackingDone,
  createWarehousePacking,
  fetchWarehousePackingById,
  updateWarehousePacking,
  deleteWarehousePacking,
  fetchWarehousePackingDropdown,
} from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  createLoading: boolean;
  createSuccess: boolean;
  currentPacking: any | null;
  updateLoading: boolean;
  updateSuccess: boolean;
  deleteLoading: boolean;
  deleteSuccess: boolean;
  dropdownData: any[];
  dropdownLoading: boolean;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
  createLoading: false,
  createSuccess: false,
  currentPacking: null,
  updateLoading: false,
  updateSuccess: false,
  deleteLoading: false,
  deleteSuccess: false,
  dropdownData: [],
  dropdownLoading: false,
};

const WarehouseIssuePackingSlice = createSlice({
  name: "WarehousePackingDone",
  initialState,
  reducers: {
    resetPackingDoneState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehousePackingDone.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehousePackingDone.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchWarehousePackingDone.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Warehouse Packing List";
      })
      .addCase(createWarehousePacking.pending, (state) => {
        state.createLoading = true;
        state.createSuccess = false;
        state.error = null;
      })
      .addCase(createWarehousePacking.fulfilled, (state, action) => {
        state.createLoading = false;
        state.createSuccess = true;
        state.error = null;
      })
      .addCase(createWarehousePacking.rejected, (state, action) => {
        state.createLoading = false;
        state.createSuccess = false;
        state.error = action.error.message || "Failed to create packing";
      })
      .addCase(fetchWarehousePackingById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehousePackingById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPacking = action.payload;
        state.error = null;
      })
      .addCase(fetchWarehousePackingById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packing details";
      })
      .addCase(updateWarehousePacking.pending, (state) => {
        state.updateLoading = true;
        state.updateSuccess = false;
        state.error = null;
      })
      .addCase(updateWarehousePacking.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = action.payload.success || true;
        state.error = null;
      })
      .addCase(updateWarehousePacking.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = false;
        state.error = action.error.message || "Failed to update packing";
      })
      .addCase(deleteWarehousePacking.pending, (state) => {
        state.deleteLoading = true;
        state.deleteSuccess = false;
        state.error = null;
      })
      .addCase(deleteWarehousePacking.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccess = true;
        state.error = null;
      })
      .addCase(deleteWarehousePacking.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccess = false;
        state.error = action.error.message || "Failed to delete packing";
      })
      .addCase(fetchWarehousePackingDropdown.pending, (state) => {
        state.dropdownLoading = true;
        state.error = null;
      })
      .addCase(fetchWarehousePackingDropdown.fulfilled, (state, action) => {
        state.dropdownLoading = false;
        state.dropdownData = action.payload;
        state.error = null;
      })
      .addCase(fetchWarehousePackingDropdown.rejected, (state, action) => {
        state.dropdownLoading = false;
        state.error = action.error.message || "Failed to fetch dropdown data";
      });
  },
});

export const { resetPackingDoneState } = WarehouseIssuePackingSlice.actions;
export default WarehouseIssuePackingSlice.reducer;
